import React, { useState, useEffect } from "react";
import { getSettings } from "../../services/settingsServices";

const InfoClub = () => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const data = await getSettings();
        if (data.length > 0) {
          setSettings(data[0]);
        }
        setLoading(false);
      } catch (error) {
        console.error("Erreur lors de la récupération des paramètres:", error);
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  if (loading || !settings?.infoclub_isactive) return null;

  return (
    <section className="py-12 px-4 bg-gray-100 dark:bg-gray-700 bg-lightBackground dark:bg-darkBackground text-black dark:text-white max-w-[1280px] mx-auto">
      <div className="bg-gradient-to-r from-slate-100 to-slate-200 dark:from-gray-700 dark:to-gray-800 rounded-2xl shadow-xl flex flex-col lg:flex-row overflow-hidden border border-gray-400 dark:border-gray-800">
        {/* Contenu à gauche */}
        <div className="lg:w-2/3 w-full p-8 flex flex-col justify-center">
          <h2 className="text-3xl font-bold text-gray-800 dark:text-white mb-4">
            {settings.infoclub_title}
          </h2>
          <div
            className="text-gray-700 dark:text-gray-300 leading-relaxed text-justify"
            dangerouslySetInnerHTML={{ __html: settings.infoclub_content }}
          />
        </div>

        {/* Image à droite */}
        <div className="lg:w-1/3 w-full max-h-[300px] lg:max-h-full">
          <img
            src="/img/infoclub.png"
            alt={settings.infoclub_title || "Info Club"}
            className="object-cover h-full w-full"
          />
        </div>
      </div>
    </section>
  );
};

export default InfoClub;
